<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Informações Gerais - {{ park.name }}</h3>
          </div>

          <form role="form" v-if="quizTemplate">
            <div class="box-body">
              <component
                v-for="q in quizTemplate.questions"
                v-if="quiz && q.isVisible"
                v-bind:key="q.uuid"
                ref="questions"
                v-on:answerUpdated="onAnswerUpdated"
                :is="getQuestionComponent(q)"
                :question="q"
                :answer="getQuestionAnswer(q)">
              </component>
            </div>

            <div class="box-footer">
              <button type="submit" class="btn btn-sm btn-primary pull-right" v-on:click.prevent="onSubmit">
                <i class="fa fa-save"></i>&nbsp; Salvar
              </button>
              <go-back-button></go-back-button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <notifier ref="notifier"></notifier>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import GoBackButton from '@/components/elements/GoBackButton'
  import QuizTemplateClient from '@/services/resource_client/quiz_template'
  import GeneralInformationsClient,
        { GENERAL_INFORMATIONS_QUIZ_TEMPLATE_UUID } from '@/services/resource_client/general_information'

  import DateQuestion from './questions/DateQuestion'
  import DateLteTodayQuestion from './questions/DateLteTodayQuestion'
  import MultipleChoiceQuestion from './questions/MultipleChoiceQuestion'
  import CollectionQuestion from './questions/CollectionQuestion'
  import BooleanFormQuestion from './questions/BooleanFormQuestion'
  import BooleanCollectionQuestion from './questions/BooleanCollectionQuestion'
  import FormQuestion from './questions/FormQuestion'
  import ItemsQuestion from './questions/ItemsQuestion'
  import Notifier from '@/components/elements/Notifier'
  import ParkClient from '@/services/resource_client/park'
  import { responseContainsCpfCnpjValidationError } from '@/utils/quizValidationErrors'

  export default {
    name: 'GeneralInformations',
    components: { Adminlte, GoBackButton, DateQuestion, Notifier, ParkClient },
    data () {
      return {
        quizTemplate: null,
        quiz: null,
        componentsPerType: {
          'date': DateQuestion,
          'multiple-choice': MultipleChoiceQuestion,
          'collection': CollectionQuestion,
          'boolean-form': BooleanFormQuestion,
          'boolean-collection': BooleanCollectionQuestion,
          'form': FormQuestion,
          'items': ItemsQuestion
        },
        customComponentsPerQuestionUuid: {
          'ce9c4656-e0d7-31f0-a1f0-06870af0f413': DateLteTodayQuestion,
          '40a146f5-c57a-306f-9187-fa743d0749a3': DateLteTodayQuestion,
          '21b007d0-3357-3ae5-8d07-cf6c8582262c': DateLteTodayQuestion,
          '0428805b-b645-3ec4-9cfe-d7b7d0247c96': DateLteTodayQuestion
        },
        park: {}
      }
    },
    props: ['parkId'],
    created () {
      this.getQuizTemplate()
      this.getQuiz()
    },
    mounted () {
      ParkClient.get(this.parkId).then(r => { this.park = r.data })
    },
    methods: {
      onAnswerUpdated (answer) {
        let questionFound = false
        this.quiz.answers.forEach(a => {
          if (a.questionUuid === answer.questionUuid) {
            a.value = answer.value
            questionFound = true
            return
          }
        })
        if (!questionFound) {
          throw new Error('AnswerNotFoundException')
        }
      },
      getQuestionComponent (q) {
        if (this.customComponentsPerQuestionUuid.hasOwnProperty(q.uuid)) {
          return this.customComponentsPerQuestionUuid[q.uuid]
        }
        return this.componentsPerType[q.type]
      },
      getQuestionAnswer (q) {
        if (!q.isVisible || this.quiz === null) {
          return
        }
        for (let answerIndex in this.quiz.answers) {
          let answer = this.quiz.answers[answerIndex]
          if (answer.questionUuid === q.uuid) {
            return answer
          }
        }
        return this.addDefaultAnswerForQuestion(q)
      },
      addDefaultAnswerForQuestion (question) {
        const defaultAnswer = {
          'questionUuid': question.uuid,
          'value': null
        }

        const answersLength = Object.keys(this.quiz.answers).length
        this.quiz.answers[answersLength] = defaultAnswer

        return defaultAnswer
      },
      getQuizTemplate () {
        QuizTemplateClient.get(GENERAL_INFORMATIONS_QUIZ_TEMPLATE_UUID, this.parkId).then(r => {
          this.quizTemplate = this.sortQuizQuestionsByRenderingOrder(r.data)
        })
      },
      sortQuizQuestionsByRenderingOrder (quiz) {
        quiz.questions.sort(function (a, b) {
          return a.renderingOrder - b.renderingOrder
        })
        return quiz
      },
      getQuiz () {
        GeneralInformationsClient.get(this.parkId).then(r => {
          if (!this.quizExists(r.data)) {
            return this.createQuiz(this.parkId)
          }
          this.quiz = r.data[0]
        })
      },
      quizExists (quiz) {
        return quiz.total !== 0
      },
      createQuiz (parkId) {
        GeneralInformationsClient.post(parkId).then(r => { this.quiz = r.data })
      },
      onSubmit () {
        let isAnswersValid = true
        this.$refs.questions.forEach(child => {
          if (!child.isValid()) {
            isAnswersValid = false
          }
        })
        if (!isAnswersValid) {
          this.showErrorNotification()
          return
        }

        setTimeout(() => {
          GeneralInformationsClient
            .put(this.quiz.uuid, this.quiz.answers.filter(this.checkEmptyAnswer))
            .then(this.$refs.notifier.showSavedFormNotification())
            .catch(e => {
              this.notifyGeneralInformationsSubmitError(e)
            })
        }, 0)
      },
      checkEmptyAnswer (answer) {
        return answer.value !== null
      },
      showSavedFormNotification () {
        this.$notify({ type: 'success', title: 'Sucesso', text: 'As informações foram salvas!' })
      },
      showErrorNotification () {
        this.$notify({ type: 'error', title: 'Ocorreu um erro', text: 'Verifique se as informações foram preenchidas corretamente e tente novamente.' })
      },
      notifyGeneralInformationsSubmitError (e) {
        const payload = e.response && e.response.data ? e.response.data : null
        if (payload && payload.errors) {
          this.errors = payload.errors
        } else {
          this.errors = null
        }
        if (responseContainsCpfCnpjValidationError(payload)) {
          this.$notify({
            type: 'error',
            title: 'CPF ou CNPJ inválido',
            text: 'Corrija os documentos informados nas informações gerais e tente novamente.'
          })
          return
        }
        this.$refs.notifier.showErrorNotification()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// GeneralInformations.vue?71c4f35d